import React, { FC, HTMLAttributes } from 'react'

import cn from 'classnames'

import classes from './block-container.module.scss'

export const BlockContainer: FC<HTMLAttributes<HTMLDivElement>> = ({
  className,
  children,
  ...rest
}) => (
  <div className={cn(classes.blockContainer, className)} {...rest}>
    {children}
  </div>
)

export default BlockContainer
